export enum FeedInGridConnectionLevel {
  LowVoltage = 1,
  MediumVoltage = 2,
  HighVoltage = 3,
}
